
import wechatCache from '../../util/wechatCache'

const wechat = {
  state: {
    WeChatInfo: ''
  },

  mutations: {
    SET_WeChat: (state, openId) => {
      wechatCache.addOpenId(openId)
      state.WeChatInfo = openId
    },
    DEL_WeChat: (state) => {
      wechatCache.delOpenId()
      state.WeChatInfo = ''
    },
  },

  actions:{
    SETWeChat({commit}, openId){
      commit('SET_WeChat', openId)
    },
    DELWeChat({commit}){
      commit('DEL_WeChat')
    }
  }
}

export default wechat



// WEBPACK FOOTER //
// ./src/store/modules/wechat.js